"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.msgFundCommunityPool = void 0;
var ow_1 = __importDefault(require("ow"));
var address_1 = require("../../../utils/address");
var ow_types_1 = require("../ow.types");
var typeurl_1 = require("../../common/constants/typeurl");
exports.msgFundCommunityPool = function (config) {
    return (function () {
        function MsgFundCommunityPool(options) {
            ow_1.default(options, 'communityPoolOptions', ow_types_1.owMsgFundCommunityPoolOptions);
            this.depositor = options.depositor;
            this.amount = options.amount;
            this.validateAddresses();
        }
        MsgFundCommunityPool.prototype.toRawAminoMsg = function () {
            return {
                type: 'cosmos-sdk/MsgFundCommunityPool',
                value: {
                    depositor: this.depositor,
                    amount: this.amount.toCosmosCoins(),
                },
            };
        };
        MsgFundCommunityPool.prototype.toRawMsg = function () {
            return {
                typeUrl: typeurl_1.COSMOS_MSG_TYPEURL.distribution.MsgFundCommunityPool,
                value: {
                    depositor: this.depositor,
                    amount: this.amount,
                },
            };
        };
        MsgFundCommunityPool.prototype.validateAddresses = function () {
            if (!address_1.validateAddress({
                address: this.depositor,
                network: config.network,
                type: address_1.AddressType.USER,
            })) {
                throw new TypeError('Provided `depositor` address doesnt match network selected');
            }
        };
        return MsgFundCommunityPool;
    }());
};
//# sourceMappingURL=MsgFundCommunityPool.js.map